import { internalApi } from "@circle-react/helpers/urlHelpers/internalApi";

import {
  reactQueryGet,
  reactQueryPut,
} from "@/react/helpers/backendRequestHelpers";

const show = (id: number) =>
  reactQueryGet(internalApi.mediaTranscripts.show({ id }));

const update = (id: number, params: any) =>
  reactQueryPut(internalApi.mediaTranscripts.update({ id }), params);

export const mediaTranscriptApi = {
  show,
  update,
};
